// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"checkboxWrapper--28Fv6","text":"text--3o6U6","notificationTitle":"notificationTitle--oO8vx"};